import { VwoService } from './../../../../shared/services/vwo/vwo.service';
import { Component, HostListener, Input, OnInit, ViewChild, OnDestroy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FundraiserService } from '../../../../shared/services/fundraiser/fundraiser.service';
import { UtilService, VariablesService, TickrService } from '../../../../shared/services';
import { AcknowledgeFormComponent } from 'src/app/core/acknowledge-form/acknowledge-form.component';
import { ICurrency } from '../../../../shared/models';
import { Subscription } from 'rxjs';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-view-supporters',
  templateUrl: './view-supporters.component.html',
  styleUrls: ['./view-supporters.component.scss']
})
export class ViewSupportersComponent implements OnInit, OnDestroy {

  private readonly AB = inject(VwoService);
  private readonly bottomSheet = inject(MatBottomSheet);

  @Input() public customTag;
  @Input() public fundraiser;
  @Input() public settings;
  @Input() public isFundraiserEnded;
  @Input() public origin;
  @Input() public donationCard?;
  @Input() public isDonated?;
  @Input() public tickrIsShown?;
  @Input() public theme = 'v1';
  tickrSubscription: Subscription[] = [];
  donorError;
  isMobile: any;
  supportersOnScroll = [];
  donorsOrderBy = 'donated_amount';
  page = {
    sortby: 'desc',
    limit: 10,
    page: 1,
    orderby: ''
  };
  payment_option = {
    wallet: 'wallet',
    paytm: 'paytm',
    upi: 'upi',
    bank: 'bank'
  };
  isLoader;
  @ViewChild('viewSupporters', { static: true }) public viewSupporters;
  supporterImg;
  isListContinue = true;
  currencyInfo: ICurrency;
  currencySubscription: Subscription;
  fakeTickrSupportersCount: any;
  willTickrShow = false;
  dialogRef;
  sheetRef: MatBottomSheetRef;

  isLoggedIn = false;
  loginPopupState = false;
  listPopupOpened = false;

  constructor(
    public fundraiserService: FundraiserService,
    public util: UtilService,
    public dialog: MatDialog,
    public vars: VariablesService,
    public tickrService: TickrService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.fakeTickrSupportersCount = this.tickrService.reduceDonorsBy;
    this.getSupportersImages();
    if (this.origin === 'stories') {
      this.page.orderby = 'id';
    } else {
      this.page.orderby = 'donated_amount';
    }
    this.getCurrency();
    if (!this.tickrService.stopTickr) {
      this.onTickrClick();
    }
    this.util.isLoggedIn.subscribe({
      next: (res) => {
        this.isLoggedIn = res;
      }
    });
  }
  /**Get Supporters images */
  getSupportersImages() {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
  }
  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  navigateToSignIn() {
    const domain_details = this.util.domain_details;
    const url = `${domain_details.domain_url}/login/login.php?redirect_uri=${encodeURIComponent(domain_details.full_url)}`;
    this.util.nativeNavigation(url);
  }
  /**Open contact dailog */
  openDialog(template): void {
    if (!this.isLoggedIn && this.vars.mandateLoginCheck) {
      this.loginPopupState = true;
      this.listPopupOpened = false;
      return;
    }
    if (this.isMobile && this.vars.showKCart) {
      this.sheetRef = this.bottomSheet.open(template, {
        panelClass: ['supportersBottomSheet', 'kartSupportersBottomSheet']
      });
    } else {
      this.dialogRef = this.dialog.open(template, {
        width: this.util.isMobile() ? '100vw' : '448px',
        maxWidth: this.util.isMobile() ? '100vw' : '80vw',
        height: this.util.isMobile() ? '90vh' : '65vh',
        panelClass: ['view-suppoters-dialog', this.vars.showKCart ? 'kartSupporterDialog' : '']
      });
    }
    this.getSupporters(this.customTag, this.page);
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: any, name) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 5) {
      this.page.page++;
      this.getSupportersOnScroll(this.customTag, this.page);
    }
  }
  /**get sort order by */
  getSortOrder(ordrby) {
    return this.donorsOrderBy === ordrby ? 'primary' : '';
  }
  sortDonors(ordrby) {
    this.donorsOrderBy = ordrby;
    this.page.orderby = ordrby;
    this.page.page = 1;
    this.isListContinue = true;
    this.getSupporters(this.customTag, this.page);
  }
  /**Supporters On scroll */
  getSupportersOnScroll(customTag, page) {
    if (this.isListContinue) {
      this.isLoader = true;
      // tslint:disable-next-line:max-line-length
      const qParam = `?with=activation;comments&limit=${page.limit}&page=${page.page}&orderBy=${page.orderby}&sortedBy=${page.sortby}`;
      this.fundraiserService.getDonors(customTag, qParam).subscribe((res: any) => {
        res.data.data = this.util.handleSupporters(res?.data?.data||[]);
        for (const item of res.data.data) {
          this.supportersOnScroll.push(item);
        }
        this.isLoader = false;
        this.isListContinue = this.checkForEmptyArray(res.data.data);
      }, (error) => {
        this.isListContinue = false;
        this.isLoader = false;
        this.donorError = this.vars.social ? error : null;
      });
    }
  }
  /**Supporters On scroll */
  getSupporters(customTag, page) {
    if (this.isListContinue) {
      // tslint:disable-next-line:max-line-length
      const qParam = `?with=activation;comments;productSales.campaignProduct.product&limit=${page.limit}&page=${page.page}&orderBy=${page.orderby}&sortedBy=${page.sortby}`;
      this.fundraiserService.getDonors(customTag, qParam).subscribe((res: any) => {
        this.supportersOnScroll = res.data.data;
        this.isListContinue = this.checkForEmptyArray(res.data.data);
      }, (error) => {
        this.isListContinue = false;
        this.donorError = this.vars.social ? error : null;
      });
    }
  }

  checkForEmptyArray(data) {
    return data && data.length ? true : false;
  }

  ackPopup() {
    this.dialog.open(AcknowledgeFormComponent, {
      data: { mode: this.payment_option.paytm },
      width: '100vw',
      height: '100vh',
      maxWidth: '600px',
      maxHeight: this.isMobile ? '100vh' : '550px',
    });
  }

  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.currencySubscription = this.util.currency.subscribe({
      next: (res) => {
        if (res) {
          this.currencyInfo = this.util.getCurrencyIcon(res);
        }
      }
    });
  }

  onTickrClick() {
    this.tickrSubscription.push(
      this.tickrService.willTickrShowObs.subscribe((data) => {
        setTimeout(() => {
          this.willTickrShow = data;
          if (this.willTickrShow) {
            this.fundraiser.raised.backers -= this.fakeTickrSupportersCount;
          }
        }, 0);
      })
    );
    this.tickrSubscription.push(
      this.tickrService.tickrClickObs.subscribe((data) => {
        if (data) {
          this.dialog.closeAll();
          this.openDialog(this.viewSupporters);
        }
      })
    );
    // this.tickrSubscription.push(
    //   this.tickrService.tickrIsShown.subscribe((data) => {
    //     if (data) {
    //       this.fundraiser.raised.beforeTickr = this.fundraiser.raised.raised;
    //       this.fundraiser.raised.raised += data.donated_amount_current;
    //       ++this.fundraiser.raised.backers;
    //     }
    //   })
    // );
  }

  signinClose(temp) {
    if (this.listPopupOpened) {
      return;
    }
    if (this.isLoggedIn || !this.vars.mandateLoginCheck) {
      this.listPopupOpened = true;
      setTimeout(() => {
        this.openDialog(temp);
      }, 10);
    } else {
      this.loginPopupState = false;
    }
  }

  closeDialog() {
    if (this.isMobile) {
      this.sheetRef?.dismiss();
    } else {
      this.dialogRef?.close();
    }
  }

  ngOnDestroy() {
    this.tickrSubscription.forEach(subscription => subscription.unsubscribe());
  }

}
